import { AddonProductCartItem, Fetched, RequestError, GroupedTicketTypes } from "../types";
import fetch from "./fetch";

const organizationId = window.ORGANIZATION_ID;

type GenericAvailableTicketTypesError = { type: "ERROR_FETCHING_AVAILABLE_TICKET_TYPES" };
export type ErrorFetchingTicketTypes = GenericAvailableTicketTypesError;

export const fetchAvailableTicketTypes = async (
  eventId: string,
  promos: (string | null)[] = [],
): Promise<
  | Fetched<{
      groupedTicketTypes: GroupedTicketTypes[];
    }>
  | RequestError<ErrorFetchingTicketTypes>
> => {
  const secrets = promos.length > 0 ? `?${promos.map((p) => `promo=${p}`).join("&")}` : "";
  const response = await fetch(
    `/api/public/v3.0/organizations/${organizationId}/events/${eventId}/available_ticket_types${secrets}`,
  );

  if (response.type !== "success") {
    return {
      status: "error",
      error: {
        type: "ERROR_FETCHING_AVAILABLE_TICKET_TYPES",
      },
    };
  }

  const json = response.response;
  return {
    status: "fetched",
    entity: {
      groupedTicketTypes: json.map((group: any) => ({
        ticketTypeGroup: group.ticket_type_group
          ? {
              ticketTypeGroupId: group.ticket_type_group.ticket_type_group_id,
              eventId: group.ticket_type_group.event_id,
              name: group.ticket_type_group.name,
              description: group.ticket_type_group.description,
              salesStart: group.ticket_type_group.sales_start
                ? new Date(group.ticket_type_group.sales_start)
                : null,
              salesEnd: group.ticket_type_group.sales_end
                ? new Date(group.ticket_type_group.sales_end)
                : null,
              validFrom: group.ticket_type_group.valid_from
                ? new Date(group.ticket_type_group.valid_from)
                : null,
              validTo: group.ticket_type_group.valid_to
                ? new Date(group.ticket_type_group.valid_to)
                : null,
              isFullDay: group.ticket_type_group.is_full_day,
              ordering: group.ticket_type_group.ordering,
              availabilityStatus: group.ticket_type_group.availability_status,
            }
          : null,
        ticketTypes: group.ticket_types.map((ttg: any) => ({
          ticketType: {
            ticketTypeId: ttg.ticket_type.ticket_type_id,
            name: ttg.ticket_type.name,
            price: ttg.ticket_type.price,
            fee: ttg.ticket_type.fee,
            vatFactor: ttg.ticket_type.vat_factor,
            description: ttg.ticket_type.description,
            secretKey: ttg.ticket_type.secret_key,
            hasNonRequiredAddons: ttg.ticket_type.has_non_required_addons,
            requiredAddonProducts: ttg.ticket_type.required_addons.map(
              (ap: any): AddonProductCartItem => ({
                addonProductId: ap.addon_product_id,
                name: ap.name,
                price: ap.price,
                vatFactor: ap.vat_factor,
                fee: ap.fee,
                description: ap.description || "",
                customerPrompt: ap.customer_prompt || "",
                soldOut: ap.availability_status === "SOLD_OUT",
                hidePrice: ap.hide_price,
                required: 1,
                minPerTicket: ap.min_per_ticket,
                maxPerTicket: ap.max_per_ticket || null,
                linkedTicketTypes: [],
              }),
            ),
            availabilityStatus: ttg.ticket_type.availability_status,
            countRule: {
              max: ttg.ticket_type.count_rule?.max || null,
              min: ttg.ticket_type.count_rule?.min || null,
              mod: ttg.ticket_type.count_rule?.mod || null,
            },
            validFrom: ttg.ticket_type.valid_from ? new Date(ttg.ticket_type.valid_from) : null,
            validTo: ttg.ticket_type.valid_to ? new Date(ttg.ticket_type.valid_to) : null,
            isFullDay: ttg.ticket_type.is_full_day,
            isSecret: ttg.ticket_type.is_secret,
            isFeatured: false,
          },
          ticketTypeGroupId: group.ticket_type_group?.ticket_type_group_id || null,
          ordering: ttg.ordering,
          promoted: ttg.promoted,
        })),
      })),
    },
  };
};
